import { TreasureChestOutlineIcon } from './TreasureChestOutlineIcon';

/**
 * author: Jeff Anders
 * id 234877A7-B920-4592-8305-EFF7AFE3E13C
 * name treasure-chest-outline
 * version: 7.2.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/treasure-chest-outline.svg
 * tags
 * - Gaming / RPG 
 * - Lock 
 * - Shopping 
 */
export const JewelCaseOutlineIcon = TreasureChestOutlineIcon;
export default JewelCaseOutlineIcon